import React from 'react';
import { WrapPanel } from './styles';
import { Heading } from './heading';
import { Content } from './content';

const PanelContent = (props: any) => {
  const { heading, content, scroll, IsModalOpen } = props;

  return (
    <WrapPanel>
      <Heading>{heading}</Heading>
      <Content isScrollDisabled={scroll} IsModalOpen={IsModalOpen}>
        {content}
      </Content>
    </WrapPanel>
  );
};

export default PanelContent;
